import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { TabNames } from '../constants';
import { activeConversationIdAtom, activeTabNameAtom } from '../store';
import useConversationsQueries from './useConversationsQueries';
import useSelectFirstConversationInTab from './useSelectFirstConversation';

export const useSelectDefaultTab = () => {
  const { isAnyQueryLoading, isAnyQueryFetching, renter, owner, captain } = useConversationsQueries();
  const setActiveTabName = useSetAtom(activeTabNameAtom);
  const selectFirstConversation = useSelectFirstConversationInTab();
  const activeConversationId = useAtomValue(activeConversationIdAtom);

  const selectDefaultTabAndFirstConversation = () => {
    if (isAnyQueryLoading || isAnyQueryFetching) return;

    if (renter.query.hasConversation) {
      setActiveTabName(TabNames.renter);
      selectFirstConversation(TabNames.renter);
    } else if (owner.query.hasConversation) {
      setActiveTabName(TabNames.owner);
      selectFirstConversation(TabNames.owner);
    } else if (captain.query.hasConversation) {
      setActiveTabName(TabNames.captain);
      selectFirstConversation(TabNames.captain);
    } else {
      setActiveTabName(TabNames.renter);
    }
  };

  useEffect(() => {
    if (activeConversationId === '') {
      // on first load when no conversation id in query
      selectDefaultTabAndFirstConversation();
    }
  }, [isAnyQueryLoading, isAnyQueryFetching]);
};
